import { defineMessage, useIntl } from 'react-intl'

const singleDashMessage = defineMessage({
  id: 'VkLLMy0yH22lcn87awn-',
  defaultMessage: '-',
})

const doubleDashMessage = defineMessage({
  id: 'VOsGevd_5SEa0C6lXIxU',
  defaultMessage: '--',
})

const messages = {
  single: singleDashMessage,
  double: doubleDashMessage,
} as const

interface Props {
  variant?: 'single' | 'double'
}

function NotAvailablePlaceholder({ variant = 'double' }: Props) {
  const intl = useIntl()
  return <>{intl.formatMessage(messages[variant])}</>
}

export default NotAvailablePlaceholder
